<template>
  <div>
    <p v-if="loading">Loading...</p>
    <p v-else-if="error">{{ error }}</p>
    <ul v-else>
      <li v-for="book in books" :key="book.filename">
        {{ book.title }}
      </li>
    </ul>
  </div>
</template>

<script>
const BUCKET_URL = 'https://books.rsvpreader.com'

export default {
  data() {
    return { books: [], loading: true, error: null }
  },
  async mounted() {
    try {
      const response = await fetch(`${BUCKET_URL}/manifest.json`)
      this.books = await response.json()
    } catch (e) {
      this.error = `Could not load books: ${e.message}`
    } finally {
      this.loading = false
    }
  },
  methods: {
    parseBook(key) {
      const filename = key.replace('books/', '')
      const withoutExt = filename.replace('.txt', '')
      const withoutId = withoutExt.replace(/^\d+-\d+-/, '')
      const withSpaces = withoutId.replace(/--/, '|||').replace(/-/g, ' ')
      const title = withSpaces.replace('|||', ', ')
      return { title, filename }
    }
  }
}
</script>